/*
 * @Author: lhx
 * @Date: 2024-07-19 17:02:40
 * @LastEditors:
 * @LastEditTime: 2024-07-28 08:57:18
 * @FilePath: \admin-web-xingyad:\开发项目\九州文化\website\dongcheng-website\src\index.js
 * @Description:
 */
import  React  from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
import MixApp from "./mixApp";
// import Background from "./Background";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <MixApp />
    {/* <Background /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
